/* src/app/shared/components/add-new-company-dialog/add-new-company-dialog.component.scss */
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}
::-webkit-scrollbar-thumb {
  background: #acacac;
  border-radius: 8px;
}
::-webkit-scrollbar-track {
}
body {
  scrollbar-face-color: #acacac;
  scrollbar-track-color: rgb(213.5, 213.5, 213.5);
}
:host .title h2 {
  font-weight: 600;
  margin: 0;
  font-family:
    "Inter",
    Arial,
    sans-serif,
    sans-serif;
  font-size: 18px;
}
:host .title mat-icon {
  cursor: pointer;
  opacity: 0.5;
}
:host .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
}
:host {
  display: block;
  padding: 10px;
}
:host mat-dialog-content {
  transition: height 0.3s ease-in-out;
  overflow: hidden;
}
:host mat-dialog-content.search-height {
  height: 100px;
}
:host mat-dialog-content.form-height {
  height: 300px;
  overflow: hidden;
}
:host mat-dialog-content.form-height-expanded {
  height: auto;
  max-height: 420px;
  overflow-x: hidden;
  overflow-y: auto;
}
:host mat-dialog-content > mat-progress-bar {
  position: absolute;
  right: 0;
}
:host mat-dialog-content mat-label.required::after {
  content: "*";
  color: red;
  margin-left: 4px;
}
:host mat-dialog-content mat-label.moved {
  padding-top: 24px;
  transition: 0.3s ease-in-out;
  display: block;
}
:host mat-dialog-content .manual-entry-form .grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 12px 0;
}
:host mat-dialog-actions button {
  width: 90px;
}
:host existing-company-warning {
  margin: 24px 0;
}
::ng-deep .mat-mdc-progress-bar {
  position: absolute !important;
  top: 70px;
  left: 0;
}
::ng-deep .mat-mdc-dialog-surface {
  overflow: hidden;
}
/*# sourceMappingURL=add-new-company-dialog.component.css.map */
